import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { fmtDateTime } from 'utilities/format';

/**
 * Two-column "Ship to" + "Status history" block at the bottom of the
 * order detail. History entries are server-stamped with actor + note.
 */
export default function OrderShipAndHistory({ order: o }) {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing='14px'>
      <Box flex='1'>
        <Typography variant='body2' fontWeight='700' mb='4px'>Ship to</Typography>
        <Typography variant='body2'>{o.shipping_address?.name || '—'}</Typography>
        <Typography variant='caption' color='text.secondary'>
          {o.shipping_address?.email || ''}
        </Typography>
        <Typography variant='body2'>
          {[o.shipping_address?.line1, o.shipping_address?.line2].filter(Boolean).join(', ')}
        </Typography>
        <Typography variant='body2'>
          {[o.shipping_address?.city, o.shipping_address?.region, o.shipping_address?.postal_code]
            .filter(Boolean).join(' ')} {o.shipping_address?.country}
        </Typography>
        {o.shipping_address?.phone && (
          <Typography variant='body2'>{o.shipping_address.phone}</Typography>
        )}
      </Box>
      <Box flex='1'>
        <Typography variant='body2' fontWeight='700' mb='4px'>Status history</Typography>
        <Stack spacing='4px'>
          {(o.status_history || []).map((h, i) => (
            <Box key={i}>
              <Typography variant='caption'>
                <strong>{h.to}</strong> by {h.actor} — {fmtDateTime(h.at)}
              </Typography>
              {h.note && (
                <Typography variant='caption' color='text.secondary' display='block'>
                  {h.note}
                </Typography>
              )}
            </Box>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
